import React from 'react';
import { Container } from '@chakra-ui/react';

export const withContainer = () => (Component: React.ComponentClass<any> | React.FC<any>) => {
  return () => {
    return (
      <Container as="main" id="main" py={4} maxWidth={'container.sm'}>
        <Component />
      </Container>
    );
  };
};
